import { SS_CONTROL_TYPE } from './form-manager.constants';

export const NOT_BOUND_CONTROL_TYPES = [
  SS_CONTROL_TYPE.HYPER_LINK,
  SS_CONTROL_TYPE.STATIC_TEXT,
  SS_CONTROL_TYPE.ZOOM,
  SS_CONTROL_TYPE.BUTTON,
  SS_CONTROL_TYPE.BUTTON_BATCH,
  SS_CONTROL_TYPE.BUTTON_SHARE_POINT,
];

export const MOVE_BUTTON_TYPES = {
  UP: 'UP',
  DOWN: 'DOWN',
};

export const ERROR_LABEL_DATASOURCE_KEY = 'dataSourceKey';
export const ERROR_LABEL_DATA_KEY_FIELD = 'dataKeyField';

export const DATASOURCE_FROM_RESOLVER = 'resolver';

export const CREATE_NEW_COMPONENT_STEPS = {
  STEP_1: 'add_data_model_button',
  STEP_2: 'show_buttons',
  STEP_3: 'add_data_model_entity',
  STEP_4: 'add_data_model_type',
  STEP_5: 'add_component_type',
};

export const CHART_DATA_PROP = 'CHART_DATA_PROP';
export const AUTOCOMPLETE = 'AUTOCOMPLETE';
export const SELECT = 'SELECT';
export const ICON_FIELD = 'ICON_FIELD';
export const CONDITIONAL_SELECT = 'CONDITIONAL_SELECT';
export const TEXT_FIELD = 'TEXT_FIELD';
export const TEXT_VIEW = 'TEXT_VIEW';
export const CONDITIONAL_TEXT_FIELD = 'CONDITIONAL_TEXT_FIELD';
export const CONTROL_TYPE_COMPONENT = 'CONTROL_TYPE_COMPONENT';
export const RADIO = 'RADIO';
export const VALIDATION_EDITOR = 'Validation Editor';
export const RULE_EDITOR = 'Rule Editor';
export const ACTION_EDITOR = 'Action Editor';
export const EXPRESSION_EDITOR = 'Expression Editor';
export const DATASOURCE_EDITOR = 'Datasource Editor';
export const MAPPING_EDITOR = 'Mapping Editor';
export const MAPPING_TEXT_FIELD = 'MAPPING_TEXT_FIELD';
export const QUERY_PARAM_EDITOR = 'QueryString Params Editor';
export const QUERY_PARAM_FIELD = 'QUERY_PARAM_FIELD';
export const ENTITY_MODEL_EDITOR = 'Entity Model';
export const INTERACTION_MODEL_EDITOR = 'Interaction Model';
export const LINK_TEXT_FIELD = 'LINK_TEXT_FIELD';
export const CHART_DATA_EDITOR = 'Chart Data Editor';
export const SELECTED_FIELDS_EDITOR = 'Selected Fields Editor';
export const EXTRA_PROMPTS_EDITOR = 'Extra Prompts Editor';

export const DATA_SOURCE_EDITOR_PROPS = ['dataSourceKey'];
export const MAPPING_EDITOR_PROPS = ['dataMappingList', 'excludedColumnsMappingList'];
export const QUERY_PARAM_EDITOR_PROPS = ['paramList'];
export const CHART_DATA_EDITOR_PROPS = ['chartData'];
export const ACTION_EDITOR_PROPS = ['update'];
export const VALIDATION_EDITOR_PROPS = ['validation'];
export const RULE_EDITOR_PROPS = [
  'required',
  'hidden',
  'viewOnly',
  'disabledWithZoom',
  'disableAdd',
  'disableEdit',
  'disableDelete',
  'editAllRows',
  'dataSourceFilter',
  'filter',
  'enableCopy',
  'showInput',
  'showPostSummaryGenerationMessage',
  'showOperationCompleteMessage',
];
export const EXPRESSION_EDITOR_PROPS = [
  'defaultValue',
  'setValue',
  'label',
  'title',
  'rowTitle',
  'style',
  'url',
  'text',
  'defaultTab',
  'dataToolTip',
  'mappingFieldName',
  'mappingEntitName',
  'predictionCode',
  'latestRevision',
  'contentType',
  'isDocumentContent',
  'officeOnlineOptions',
  'meaning',
  'tooltipText',
  'emptySectionMessage',
  'operationDelayMessage',
  'regulatoryTerms',
  'termHierarchy',
  'scormContentTypeOptions',
  'scormLaunchOptions',
  'stepId',
  'itmId',
  'containerWorkflowKey',
  'isApprovedforASR',
  'fnpCode',
  'regulatoryBody',
  'regulatoryCenter',
  'currentWorkFlowId',
  'workflowKey',
  'decisionTreeName',
  'minValue',
  'maxValue',
  'sourceRecordId',
  'postSummaryGenerationMessage',
  'operationCompleteMessage',
];
export const SELECTED_FIELDS_EDITOR_PROPS = ['sourceFields'];
export const ENTITY_FIELD_PICKER_EDITOR_PROPS = ['summaryGenerationDate'];
export const EXTRA_PROMPTS_EDITOR_PROPS = ['extraPrompts'];

export const CONTROLLER_TITLE_FORM = [SS_CONTROL_TYPE.FORM];
export const CONTROLLER_TITLE_PANEL = [
  SS_CONTROL_TYPE.PANEL,
  SS_CONTROL_TYPE.REPEATING_PANEL,
  SS_CONTROL_TYPE.GRID,
  SS_CONTROL_TYPE.SINGLE_TAB,
  SS_CONTROL_TYPE.BUTTON,
];

export const DATASOURCE_TYPE_ENUM = {
  3: 'SMARTSOLVEDATA',
  4: 'EXTERNALDATA',
  6: 'LISTDATA',
  7: 'SETTINGS',
  100: 'FORMDATA',
};

export const DATASOURCE_TYPE_SMARTSOLVEDATA = 3;
export const DATASOURCE_TYPE_LISTDATA = 6;
export const DATASOURCE_TYPE_SETTINGS = 7;
export const DATASOURCE_TYPE_EXTERNALDATASOURCE = 4;
export const DATASOURCE_TYPE_PREDEFINED = 99;
export const DATASOURCE_TYPE_FORMDATA = 100;

export const PROPNAMES = [
  'multiSelect',
  'required',
  'hidden',
  'viewOnly',
  'label',
  'setValue',
  'defaultValue',
  'defaultTab',
  'title',
  'rowTitle',
  'disableAdd',
  'disableEdit',
  'disableDelete',
  'editAllRows',
  'dataSourceFilter',
  'dataSourceKey',
  'dataValueField',
  'dataTextField',
  'text',
  'style',
  'url',
  'allowMaximizing',
  'dataMappingList',
  'dataToolTip',
  'fieldName',
  'supportRichText',
  'mappingFieldName',
  'mappingEntitName',
  'predictionCode',
  'filter',
  'formatType',
  'latestRevision',
  'contentType',
  'isDocumentContent',
  'officeOnlineOptions',
  'scormContentTypeOptions',
  'linkType',
  'needSignature',
  'meaning',
  'lookupType',
  'enforceSelection',
  'supportRichText',
  'translateData',
  'initialRows',
  'excludedColumnsMappingList',
  'enableCopy',
  'gridType',
  'savedSearchType',
  'paramList',
  'expandableRows',
  'tooltipText',
  'targetId',
  'emptySectionMessage',
  'causesValidation',
  'icon',
  'batchProcessView',
  'batchProcessViewPrimaryKey',
  'batchProcessUpdatedStatusCode',
  'batchProcessUpdatedPrimaryKey',
  'batchProcessUpdatedPrimaryKeyValue',
  'batchProcessUpdatedUserCode',
  'batchProcessUpdatedEntityName',
  'batchProcessUpdatedModifedDate',
  'batchProcessWorkflowInstanceId',
  'batchProcessWorkflowKey',
  'batchProcessWorkflowStepInstanceId',
  'batchProcessWorkflowStepName',
  'batchProcessChildRecordInstanceId',
  'batchProcessContainerWorkflowKey',
  'batchProcessEntityRecordInstanceId',
  'batchProcessParentEntityName',
  'batchProcessParentWorkflowInstanceId',
  'buttonType',
  'dataLookUpType',
  'dataObject',
  'searchName',
  'operationDelayMessage',
  'regulatoryTerms',
  'termHierarchy',
  'scormLaunchOptions',
  'stepId',
  'itmId',
  'containerWorkflowKey',
  'isApprovedforASR',
  'fnpCode',
  'regulatoryBody',
  'regulatoryCenter',
  'currentWorkFlowId',
  'workflowKey',
  'decisionTreeName',
  'formHelpLinkUrl',
  'formHelpLinkText',
  'minValue',
  'maxValue',
  'showInput',
  'color',
  'fontSize',
  'chartData',
  'height',
  'width',
  'yTicks',
  'suffix',
  'sourceFields',
  'displayIcon',
  'displayIconColor',
  'sourceRecordId',
  'showOperationCompleteMessage',
  'sourceEntityName',
  'showPostSummaryGenerationMessage',
  'extraPrompts',
  'summaryGenerationDate',
  'postSummaryGenerationMessage',
  'operationCompleteMessage',
  'previewOnly',
  'disabledWithZoom',
];

export const CONTAINER_CONTROLLERS = [
  'ssGrid',
  'ssPanel',
  'ssRepeatingPanel',
  'ssFieldGroup',
  'ssClusterColumnChart',
  'sourceFields',
];

export const ENABLED_CONTROLLERS = [
  'uniqueIdentifier',
  'header',
  'rowHeader',
  'rowTitle',
  'dataSourceFilter',
  'dataSourceKey',
  'dataValueField',
  'dataTextField',
  'dataToolTip',
  'orientation',
  'excludedColumnsMappingList',
  'disablePagination',
];

export const DATASOURCE_LISTDATA_DEFAULT_FIELDS = [
  'LST_VALUE',
  'LST_VALUE1',
  'LST_VALUE2',
  'LST_VALUE3',
  'LST_VALUE4',
  'LST_VALUE5',
  'LST_PARENT_VALUE',
];

export const AUTOGENERATED_ZOOM_INFO = `This zoom control is automatically generated by the system
  based on fields properties defined at the Entity level. To change any of its properties,
  associate a new zoom control to the text box.`;

export const ZOOM_ENABLED_PROPS = [
  'hidden',
  'dataLookUpType',
  'dataObject',
  'dataMappingList',
  'filter',
  'searchName',
  'paramList',
  'multiSelect',
];

export const MERGED_ZOOM_ENABLED_PROPS = ['hidden', 'dataMappingList', 'filter', 'multiSelect'];

export const CONTROL_TYPES_WITH_INTERACTION_ACTION = [
  SS_CONTROL_TYPE.FORM,
  SS_CONTROL_TYPE.CHECK_BOX,
  SS_CONTROL_TYPE.TEXT_BOX,
  SS_CONTROL_TYPE.TEXT_AREA,
  SS_CONTROL_TYPE.NUMERIC_TEXT_BOX,
  SS_CONTROL_TYPE.DATE_BOX,
  SS_CONTROL_TYPE.RADIO_BUTTON_LIST,
  SS_CONTROL_TYPE.DROP_DOWN,
  SS_CONTROL_TYPE.SLIDER,
];

export const CONTROL_TYPES_WITH_SAVED_SEARCH_CONFIG = [
  SS_CONTROL_TYPE.ZOOM,
  SS_CONTROL_TYPE.SAVED_SEARCH,
  SS_CONTROL_TYPE.AI_SIMILAR_RECORDS,
];

export const CONTROL_TYPES_PROPERTY_TABS_ONLY = [
  SS_CONTROL_TYPE.HYPER_LINK,
  SS_CONTROL_TYPE.TEXT_VIEW,
  SS_CONTROL_TYPE.GRID_COLUMN,
  SS_CONTROL_TYPE.GRID,
  SS_CONTROL_TYPE.PANEL,
  SS_CONTROL_TYPE.REPEATING_PANEL,
  SS_CONTROL_TYPE.TAB_SET,
  SS_CONTROL_TYPE.SINGLE_TAB,
  SS_CONTROL_TYPE.BUTTON,
  SS_CONTROL_TYPE.BUTTON_SHARE_POINT,
  SS_CONTROL_TYPE.BUTTON_BATCH,
  SS_CONTROL_TYPE.BUTTON_BULK_UPLOAD,
  SS_CONTROL_TYPE.BUTTON_OFFICE_ONLINE,
  SS_CONTROL_TYPE.BUTTON_CONTROL_PRINT,
  SS_CONTROL_TYPE.SUB_GRID,
  SS_CONTROL_TYPE.FIELD_GROUP,
  SS_CONTROL_TYPE.STATIC_TEXT,
  SS_CONTROL_TYPE.ADVANCED_TEXT_BOX,
  SS_CONTROL_TYPE.ZOOM,
  SS_CONTROL_TYPE.REPOSITORY_ZOOM,
  SS_CONTROL_TYPE.MODAL,
  SS_CONTROL_TYPE.SAVED_SEARCH,
  SS_CONTROL_TYPE.FILE_INPUT,
  SS_CONTROL_TYPE.FILE_VIEWER,
  SS_CONTROL_TYPE.BUTTON_INSPECTION_MEASUREMENT_DATA,
  SS_CONTROL_TYPE.SCORM_FILE_INPUT,
  SS_CONTROL_TYPE.REGULATORY_TERMS_ZOOM,
  SS_CONTROL_TYPE.BUTTON_SCORM,
  SS_CONTROL_TYPE.BUTTON_DECISION_TREE,
  SS_CONTROL_TYPE.ICON,
  SS_CONTROL_TYPE.CLUSTER_COLUMN_CHART,
  SS_CONTROL_TYPE.AI_SIMILAR_RECORDS,
  SS_CONTROL_TYPE.ROLE_ACTORS_MANAGEMENT,
];

export const CONTROL_TYPES_ON_CHANGE_AND_DATA_SOURCE_TABS = [SS_CONTROL_TYPE.FORM];

export const SQL_DICTIONARY = {
  EQ: 'Equals To',
  SW: 'Starts With',
  EW: 'Ends With',
  CT: 'Contains',
  GT: 'Greater Than',
  GTEQ: 'Greater Than Equal To',
  LT: 'Less Than',
  LTEQ: 'Less Than Equal To',
  NEQ: 'Does Not Equal To',
  ISNULL: 'Is Null',
  ISNOTNULL: 'Is Not Null',
};

export const OPERATION_TYPE_FIELD_DICTIONARY = {
  SET_DEFAULT: 'Set default',
  UPDATE_FIELD: 'Update field',
};

export const INTERACTION_TYPE_FIELD = {
  ...OPERATION_TYPE_FIELD_DICTIONARY,
  ADD_ROW: 'Add new row',
  CLEAR_TABLE: 'Clear table',
  REBIND_CANVAS: 'Refresh canvas',
};

export const PARAMETER_TYPE_VALUES = {
  column: 'column',
  table: 'table',
  'unique identifier': 'unique identifier',
};

export const OPERATION_TYPE_VALIDATION_FIELD_DICTIONARY = { SET_ERROR: 'Set error' };

export const OPEN_PARENTHESIS = {
  '(': '(',
  '': '',
};

export const CLOSE_PARENTHESIS = {
  ')': ')',
  '': '',
};

export const LOGICAL_OPERATORS = {
  AND: 'AND',
  OR: 'OR',
};

export const FORM_HISTORY_STATUSES = {
  0: 'Inworks',
  1: 'Published',
  2: 'Archived',
};

export const FORM_STATUS_INWORKS = 0;

export const MAX_QUANTITY_SELECTED_ROWS = 2;

export const FORM_RELEASE_TYPE_PILGRIM = 'PILGRIM';
export const FORM_RELEASE_TYPE_CUSTOM = 'CUSTOM';
export const FORMS_DESIGN_RIGHT = 'FORMS_DESIGN';
export const STD_PILGRIM_RIGHT = 'STD_PILGRIM';

export const URL_QUERY_PARAMS = {
  FORM_ID: 'formId',
};

export const EXPRESSION_EDITOR_DEFAULT_HEIGHT = 550;
export const EXPRESSION_EDITOR_MIN_HEIGHT_COEFFICIENT = 0.3;
export const EXPRESSION_EDITOR_MAX_HEIGHT_COEFFICIENT = 0.7;
export const EXPRESSION_EDITOR_TEXT_FIELD_OFFSET = 25;

export const TOP_PANEL_COEFFICIENT = 0.65;
export const BOTTOM_PANEL_COEFFICIENT = 0.35;
export const LAYOUT_HEADER_OFFSET = 157;
export const VERTICAL_HANDLER_OFFSET = 5;

export const SAVE_ACTION_TYPE = {
  SAVE_AS_PILGRIM: 'SaveAsPilgrim',
  SAVE_AS_OTHER_FORM: 'SaveAs',
  CREATE_FORM: 'Create',
  IMPORT: 'Import',
  IMPORT_AS_PILGRIM: 'ImportAsPilgrim',
};

export const SAVED_SEARCH_TRAINING_SESSION_SIGNUP_TYPE = 'TrainingSessionSignup';

export const UPDATE_DATASOURCES_ACTION = 'updateDatasources';
export const UPDATE_CONTROL_ACTION = 'updateControl';
export const ADD_CONTROL_ACTION = 'addControl';
export const DELETE_CONTROL_ACTION = 'deleteControl';
export const MOVE_CONTROL_ACTION = 'moveControl';

export const UNIFIED_ID_PROPERTIES = ['id', 'handlerId', 'uniqueIdentifier'];

export const ALL_SUPPORTED_UPDATE_ACTIONS_TYPES = [
  'SET_DEFAULT',
  'UPDATE_FIELD',
  'ADD_ROW',
  'CLEAR_TABLE',
  'REBIND_CANVAS',
];
export const isInteractionAction = (type) =>
  ['ADD_ROW', 'CLEAR_TABLE', 'REBIND_CANVAS'].includes(type);

export const isUpdateAction = (type) => ['SET_DEFAULT', 'UPDATE_FIELD'].includes(type);

export const INTERACTION_ACTION_DUMMY_TYPE_UNIQUE_IDENTIFIER = 'unique identifier';
export const INTERACTION_ACTION_DUMMY_TYPE_TABLE = 'table';

export const INTERACTION_ACTION_PARAMETER_TYPE_CONTROL = 'control';
export const INTERACTION_ACTION_PARAMETER_TYPE_TABLE = 'table';

export const MAX_TEXT_VIEWS_QUANTITY = 1;

export const ICON_DEFAULT_SIZE = 'medium';
export const ICON_DEFAULT_COLOR = 'black';

export const DEFAULT_CLUSTER_COLUMN_CHART_DATA = [
  {
    label: '2014',
    data: [{ Canada: 230, France: 300 }],
  },
  {
    label: '2015',
    data: [{ Canada: 330, France: 280 }],
  },
  {
    label: '2016',
    data: [{ Canada: 360, France: 330 }],
  },
  {
    label: '2017',
    data: [{ Canada: 300, France: 430 }],
  },
  {
    label: '2018',
    data: [{ Canada: 240, France: 410 }],
  },
];

export const DEFAULT_CLUSTER_COLUMN_CHART_DATA_MESSAGE =
  'Default data is displayed. Please, provide your data';

export const DEFAULT_VIEW_TYPE = '3';

export const SUMMARY_VIEW_TYPES = [
  { label: 'Additions Markup', value: '1' },
  { label: 'Highlight Key Phrases', value: '2' },
  { label: 'Basic', value: '3' },
];

export const NEED_SIGNATURE_PROP_HELPER_TEXT =
  "For task forms, if button type is 'Sign-off', this is driven by the Task property 'Signature Required' available in the Workflow Designer.";
